<template>
    <div class="col-12">
        <div class="" v-for="(file, $index) in filesForDownload" :key="$index">
            <div class="row">
                <div class="col-11">
                    <file-download v-if="file.id"
                                   :file="file"
                                   :type="file.docTypeCode">
                    </file-download>
                </div>
                <div class="col-1" v-if="!details">
                    <i class="fas fa-trash text-danger pointer" @click="deleteSavedFile(file.id, $index)"></i>
                </div>
            </div>
        </div>
        <div v-if="!details">
            <vs-upload ref="dynamicFileUploadRef"
                       multiple
                       :text="$t('addFile')"
                       :showUploadButton="false"
                       :accept="accept"
                       @change="fileChanged"
                       @on-delete="fileRemoved"
                       aria-describedby="descriptionHelp">
            </vs-upload>
        </div>
        <transition-group name="fileDescriptionAnimation" enter-active-class="animated zoomInDown"
                          leave-active-class="animated zoomOutUp" class="col-12">
            <div class="col-12 mt-2 border border-secondary rounded fileDescription"
                 v-for="file in model.fieldValue.files"
                 :key="file.fileName">
                <label>{{ file.fileName }}</label>
                <div><input class="form-control" :placeholder="$t('description')" v-model="file.fileDescription"/></div>
            </div>
        </transition-group>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn :
            model.description }}</small>
    </div>
</template>

<script>
    import { EditorComponentModel, File as FileModel, FileDetails } from '../../models/models';
    import FileDownload from '../common/FileDownload';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            value: String,
            model: {
                type: EditorComponentModel
            },
            files: Array,
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            },
            accept: {
                type: String,
                default: 'image/jpg,image/jpeg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        },
        components: {
            FileDownload
        },
        data() {
            return {
                filesForDownload: [],
                activePrompt: false,
                originalModel: new EditorComponentModel(),
            }
        },
        computed: {
            ...mapGetters(['isEnVersion', 'fileSizeLimit']),
        },
        methods: {
            fileChanged() {
                for (let i = 0; i < this.$refs.dynamicFileUploadRef.$refs.fileInput.files.length; i++) {
                    let file = this.$refs.dynamicFileUploadRef.$refs.fileInput.files[i];
                    if (!file || file.added) {
                        continue;
                    }

                    if (file.size > this.fileSizeLimit) { // 10 MB
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.fileSizeLimitExceeded', { maxSize: this.fileSizeLimit / 1048576 }),
                            color: 'danger',
                        });
                        continue;
                    }

                    file.added = true;

                    this.model.fieldValue.files.push(new FileModel({
                        fileName: file.name,
                        content: file,
                        uid: this._uid,
                        fileDescription: '',
                        registerEntityFieldValueId: this.model.fieldValue.id
                    }));
                }

                this.model.fieldValue.textValue = this.getSeparatedFileNames();
            },
            fileRemoved(fileToRemove) {
                const indexToDelete = this.files.findIndex(x => x.name === fileToRemove.name);
                this.model.fieldValue.files.splice(indexToDelete, 1);
                this.model.fieldValue.textValue = this.getSeparatedFileNames();
            },
            getSeparatedFileNames() {
                let fileNames = [];
                this.model.fieldValue.files.forEach(file => {
                    fileNames.push(file.fileName);
                });

                return fileNames.join('|');
            },
            deleteSavedFile(fileId, fileIndex) {
                this.$emit('deleteSavedFile', fileId);
                this.filesForDownload.splice(fileIndex, 1);
            },
            async checkForSavedFiles() {
                try {
                    if (this.model.fieldValue.id && this.model.fieldValue.id > 0) {
                        const result = await this.$http.get(`/api/DynamicRegisters/GetFilesDetailsForDownload/${this.model.fieldValue.id}`);
                        if (result) {
                            result.data.forEach(detailsInfo => {
                                this.filesForDownload.push(new FileDetails(detailsInfo));
                            });
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        },
        mounted() {
            this.model.fieldValue.uid = this._uid;
            this.checkForSavedFiles();
            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        }
    }
</script>
